<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage petty accounts</small>
      </legend>
      <div>
        <div class="pettyaccountsLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size:24px; color: blue"></i>loading pettyaccounts...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemPettyaccounts"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
        ></vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Petty acount",
          field: "pettyaccounts_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by petty account"
          }
        },
        {
          label: "Submitted by",
          field: "fullname",
          type: "text",
        }
        
      ]
    };
  },
  created() {
    this.loadPettyaccounts();
  },
  computed: {
    ...mapGetters(["systemPettyaccounts"])
  },
  methods: {
    ...mapActions(["loadPettyaccounts"])
  }
};
</script>


// WEBPACK FOOTER //
// src/pettyaccounts/managepettyaccounts.vue